
export const themeMasterEndpoints = (builder) => ({
  /**
   * LIST: getThemeList
   * NOTE: Your controller reads pagination from req.body, so we use POST.
   * Expects payload: { pageNumber, pageSize, columnName, value }
   */
  getThemes: builder.query({
    query: (payload = {}) => ({
      url: '/admin/theme/list',    // adjust if your router uses a different path
      method: 'POST',
      body: payload,
    }),
    transformResponse: (response) => ({
      data: response?.data ?? [],
      totalCount: response?.totalCount ?? 0,
      success: !!response?.success,
      message: response?.message ?? '',
    }),
    providesTags: (result) => {
      if (!result || !Array.isArray(result.data)) return ['Theme'];
      const itemTags = result.data.map((t) => {
        const id = t.ThemeID ?? t.ThemeId ?? t.id ?? null;
        return { type: 'Theme', id };
      });
      return [...itemTags, { type: 'Theme', id: 'LIST' }];
    },
  }),

  /**
   * CREATE or UPDATE theme (uploads files)
   * The controller expects multipart/form-data with either logo OR letterhead.
   * Pass FormData as the arg to this mutation.
   */
  createOrUpdateTheme: builder.mutation({
    query: (formData) => {
      // formData must be a FormData instance containing fields + files
      return {
        url: '/admin/theme', 
        method: 'POST',
        body: formData,
        // Do NOT set Content-Type header here; the browser will set boundary when sending FormData.
      };
    },
    // On success, invalidate the theme list and (optionally) an individual item.
    invalidatesTags: [{ type: 'Theme', id: 'LIST' }, 'Theme'],
  }),

  /**
   * DELETE a single theme by id
   */
  deleteTheme: builder.mutation({
    query: (id) => ({
      url: `/admin/delete-Theme/${id}`, // adjust path if needed
      method: 'DELETE',
    }),
    invalidatesTags: (result, error, id) => [{ type: 'Theme', id }, { type: 'Theme', id: 'LIST' }],
  }),
});
